import { useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { compressImage } from "@/lib/image";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function fullUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BACKEND}${path}`;
}

export default function ImageUploader({ value, onChange, label = "Capa", testid = "cover-uploader", aspect = "aspect-video", square = false }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!/^image\/(jpeg|jpg|png)$/.test(file.type)) { toast.error("Use uma foto JPG ou PNG."); return; }
    setUploading(true);
    try {
      const blob = await compressImage(file, { square });
      if (blob.size > 2 * 1024 * 1024) { toast.error("Imagem muito grande mesmo após compressão (máx 2MB)."); return; }
      const fd = new FormData();
      fd.append("file", blob, "foto.jpg");
      const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
    }
  };

  const url = fullUrl(value);

  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">{label}</div>
      <div className={`${aspect} relative rounded-xl border border-dashed border-white/15 overflow-hidden bg-muted/40`}>
        {url ? (
          <>
            <img src={url} alt="" className="absolute inset-0 w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(null)} className="absolute top-2 right-2 h-8 w-8 rounded-full bg-black/70 grid place-items-center press" data-testid={`${testid}-remove`}>
              <X className="w-4 h-4" />
            </button>
          </>
        ) : (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-muted-foreground press"
            data-testid={`${testid}-button`}
          >
            {uploading ? <Loader2 className="w-6 h-6 animate-spin" /> : <Camera className="w-6 h-6" />}
            <span className="text-xs">{uploading ? "Enviando..." : "Toque pra escolher uma foto"}</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png" className="hidden" onChange={handle} data-testid={`${testid}-input`} />
    </div>
  );
}
